<template>
  <card type="password">
    <span slot="header">
      <div class="row" style="margin-bottom: 15px;">
        <div class="col-md-12">
          <base-button simple type="warning" block v-on:click="pwdForm = !pwdForm">Change password</base-button>
        </div>
      </div>
    </span>
    <form @submit.prevent class="card-body" v-if="pwdForm">
      <div class="row">
        <div class="col-md-12">
          <base-input label="Old password"
                      type="password"
                      placeholder="..."
                      v-model="passwords.old"
                      v-bind:error="errors.old"
                      v-bind:class="{ 'has-danger': !validation.old }">
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <base-input label="New password"
                      type="password"
                      placeholder="..."
                      v-model="passwords.new"
                      v-bind:error="errors.new"
                      v-bind:class="{ 'has-danger': !validation.new }">
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <base-input label="Confirm password"
                      type="password"
                      placeholder="..."
                      v-model="passwords.conf"
                      v-bind:error="errors.conf"
                      v-bind:class="{ 'has-danger': !validation.conf }">
          </base-input>
        </div>
      </div>
      <div class="row" style="margin-top: 15px;">
        <div class="col-md-12">
          <base-button class="animation-on-hover" v-on:click="changePassword" block type="danger">Change password</base-button>
        </div>
      </div>
    </form>
  </card>
</template>

<script>
    export default {
      props: ['passwords'],
      name: "password-card",
      data(){
        return{
          pwdForm: false,
          errors: { old:'', new:'',conf:'' },
          validation: { old:true, new:true, conf:true },
        }
      },
      methods:{
        changePassword(){
          this.validation.old = (this.passwords.old !== '');
          this.validation.new = (this.passwords.new !== '');
          this.validation.conf = (this.passwords.conf !== '' && this.passwords.new === this.passwords.conf);
          this.errors.old = (!this.validation.old) ? 'Password could not be empty' : '';
          this.errors.new = (!this.validation.new) ? 'Password could not be empty' : '';
          this.errors.conf = (!this.validation.conf) ? 'Password could not be empty and must be identical' : '';
          if(this.validation.old && this.passwords.new && this.passwords.conf){
            this.$emit('change-password');
          }
        },
      }
    }
</script>

<style scoped>
  .has-danger::after{
    top:46px;
  }
  .card-body{
    margin-top: -30px;
  }
</style>
